import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { authStore } from '@/stores/authStore';
import { useTranslation } from 'react-i18next';

const TitleManager = observer(() => {
  const { t } = useTranslation();
  const { currentOrganization } = authStore;

  useEffect(() => {
    // Set document title based on organization
    if (currentOrganization) {
      document.title = currentOrganization.name;
    } else {
      document.title = t('common.sensorLab', 'SensorLab');
    }
  }, [currentOrganization, t]);

  // This component doesn't render anything
  return null;
});

export default TitleManager; 